import { defineComponent, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageBox, AccountInfo, withLoading } from '@hems/component';
import { UserInfoService } from '@hems/service';
import PrivacyPopup from '@/components/popup/PrivacyPopup.vue';
export default defineComponent({
    name: 'UserInfo',
    components: {
        AccountInfo,
        PrivacyPopup,
    },
    emits: ['close', 'openPrivacyPopup', 'withdrawal'],
    async setup() {
        const { t } = useI18n();
        const messageBox = useMessageBox();
        const userInfoService = new UserInfoService(window.axiosInstance.axios);
        const accountInfo = await getAccountInfo();
        const state = reactive({
            accountInfo,
            privacyPopup: false,
        });
        const saveAccountInfo = withLoading(async (params) => {
            const { email, password, mpn_no, user_nm, bld_area_val, direct_marketing, usage_report, local_mpn_no, alarm_mail_recv_flag, } = params;
            await userInfoService.updateGeneralAccountInfo({
                email,
                password,
                mpn_no,
                user_nm,
                bld_area_val,
                direct_marketing,
                usage_report,
                local_mpn_no,
            });
            await userInfoService.updateGeneralAccountAlarmFlag(alarm_mail_recv_flag);
            state.accountInfo = await getAccountInfo();
            messageBox.alert(t('message.save_success')).open();
        });
        async function getAccountInfo() {
            return await userInfoService.getGeneralAccountInfo();
        }
        function openPrivacyPopup() {
            state.privacyPopup = true;
        }
        function closePrivacyPopup() {
            state.privacyPopup = false;
        }
        return {
            state,
            saveAccountInfo,
            openPrivacyPopup,
            closePrivacyPopup,
        };
    },
});
